import { render, staticRenderFns } from "./FreeFreight.vue?vue&type=template&id=6a8aa8da&"
import script from "./FreeFreight.vue?vue&type=script&lang=js&"
export * from "./FreeFreight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports